import { render, staticRenderFns } from "./FieldTextarea.vue?vue&type=template&id=126ca552&scoped=true"
import script from "./FieldTextarea.vue?vue&type=script&lang=js"
export * from "./FieldTextarea.vue?vue&type=script&lang=js"
import style0 from "./FieldTextarea.vue?vue&type=style&index=0&id=126ca552&prod&scoped=true&lang=css"
import style1 from "./FieldTextarea.vue?vue&type=style&index=1&id=126ca552&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126ca552",
  null
  
)

export default component.exports